// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Reports-Sales-ReportSummary-__ReportSummary___fhKsv","table-wrapper":"app-pages-Reports-Sales-ReportSummary-__ReportSummary___1z2Qa","table-wrapper-responsive":"app-pages-Reports-Sales-ReportSummary-__ReportSummary___bt1IP"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Reports/Sales/ReportSummary/ReportSummary.css
// module id = 2490
// module chunks = 0